import React from 'react';
import { useAppDispatch } from '../../../../../app/redux/useAppSelector';
import EmojiPicker, {
  EmojiPickerContainer,
} from '../../../../../components/EmojiPicker';
import reactionIcon from '../../../../../icons/non-prefilled/16x16/reaction.svg';
import { useCreateReaction } from '../../../../../post/MagneticWall';
import { EditorActions } from '../../../../editorSlice';
import type { Blot } from '../../../../types';
import ToolbarButton from '../ToolbarButton';
import selectBlotAndWaitMagneticWallUpdate from './selectBlotAndWaitMagneticWallUpdate';

interface ToolbarReactionButtonProps {
  blot?: Blot;
  onPickerOpenChange?: (open: boolean) => void;
}

const ToolbarReactionButton = ({
  blot,
  onPickerOpenChange,
}: ToolbarReactionButtonProps) => {
  const dispatch = useAppDispatch();

  const createReaction = useCreateReaction();

  return (
    <ToolbarButton
      icon={reactionIcon}
      tooltip="Add reaction"
      popOverHideCaret
      renderPopOver={(onClose: () => void) => (
        <EmojiPickerContainer>
          <EmojiPicker
            onPick={(picked: string) => {
              createReaction(picked);
              onClose();
            }}
          />
        </EmojiPickerContainer>
      )}
      onPopOverOpenChange={async (open: boolean) => {
        onPickerOpenChange?.(open);

        if (open && blot) {
          await selectBlotAndWaitMagneticWallUpdate(blot);
        }
        dispatch(EditorActions.setIsPickingReaction(open));
      }}
    />
  );
};

export default ToolbarReactionButton;
